<div class="card" >
  <div class="card-container">
    <div class="row">
      <div class="col-12" text-center>
        <h4>You have one new chat request</h4>
      </div>
      </div>
      <div class="row">
        <div class="col-6 text-center">
        <button class="btn btn-success" (click)="acceptRequest()">Accept</button>
        </div>
        <div class="col-6 " text-center>
          <button class="btn btn-danger" (click)="rejectRequest()">Reject</button>       
        </div>
      </div>
  </div>
   <div>
      <audio id="audio">
          <source src="assets/sounds/aa.mp3" type="audio/mpeg">
      </audio>
  </div>
  <div>
    <audio id="audio2">
      <source src="assets/sounds/sessionfinish.mp3" type="audio/mpeg">
    </audio>
  </div>
</div>